import client from "src/api/client";
import type { TestStatus } from "src/api/interfaces/nest";
import type { NestGetHistoryResponse } from "src/api/interfaces/nest/api";
import { useCountrySelection } from "src/components/Contexts/CountrySelectionContext";
import { useNest } from "src/components/Contexts/NestContext";
import { useAsyncFetcher } from "./useAsyncFetcher";

interface UseNestHistoryFetcherParams {
  useCaseId: string;
  submissionDateGte?: Date;
  submissionDateLte?: Date;
  status?: TestStatus;
}

export const useNestHistoryFetcher = (params: UseNestHistoryFetcherParams) => {
  const { selectedCountry } = useCountrySelection();
  const { partnerCode } = useNest();

  return useAsyncFetcher<NestGetHistoryResponse | undefined>(
    () =>
      client.getNestHistory({
        useCaseId: params.useCaseId,
        submissionDateGte: params.submissionDateGte?.toISOString(),
        submissionDateLte: params.submissionDateLte?.toISOString(),
        status: params.status,
        countryCode: selectedCountry?.countryCode,
        partnerCode: partnerCode ?? undefined,
      }),
    undefined,
    [
      params.useCaseId,
      params.submissionDateGte,
      params.submissionDateLte,
      params.status,
      selectedCountry?.countryCode,
      partnerCode,
    ],
    !!selectedCountry?.countryCode
  );
};
